/**
 * Simple transport logger
 * Enable with: localStorage.setItem('SW_DEBUG_TRANSPORT', 'true')
 */ const isTransportDebugEnabled = ()=>{
    if (typeof localStorage === "undefined" || !localStorage) return false;
    return localStorage?.getItem("SW_DEBUG_TRANSPORT") === "true";
};
const TRANSPORT_COLORS = {
    WebKit: "#9C27B0",
    Android: "#4CAF50",
    Editor: "#2196F3",
    Transport: "#FF9800"
};
export const createTransportLogger = (transportName)=>{
    const color = TRANSPORT_COLORS[transportName] || "#999";
    const log = (level, message, ...args)=>{
        if (!isTransportDebugEnabled() && level === "debug") return;
        const prefix = `%c[${transportName}]%c ${message}`;
        const styles = [
            `color: ${color}; font-weight: bold`,
            "color: inherit"
        ];
        switch(level){
            case "error":
                console.error(prefix, ...styles, ...args);
                break;
            case "warn":
                console.warn(prefix, ...styles, ...args);
                break;
            case "info":
                console.info(prefix, ...styles, ...args);
                break;
            default:
                console.log(prefix, ...styles, ...args);
        }
    };
    return {
        debug: (message, ...args)=>log("debug", message, ...args),
        info: (message, ...args)=>log("info", message, ...args),
        warn: (message, ...args)=>log("warn", message, ...args),
        error: (message, ...args)=>log("error", message, ...args)
    };
};
export var MessageDirection = /*#__PURE__*/ function(MessageDirection) {
    MessageDirection["ToPaywall"] = "to_paywall";
    MessageDirection["FromPaywall"] = "from_paywall";
    MessageDirection["ToPaywallUi"] = "to_paywall_ui";
    MessageDirection["FromPaywallUi"] = "from_paywall_ui";
    return MessageDirection;
}({});
// TODO Make sure messages? match incomingOutoing?
export const wrap = (message, messageDirection)=>{
    var events;
    if (!Array.isArray(message)) {
        events = [
            message
        ];
    } else {
        events = message;
    }
    const payload = {
        direction: messageDirection,
        version: 1,
        payload: {
            events
        }
    };
    return JSON.stringify(payload);
};
const buildNopValidator = ()=>{
    return {
        parse: (arg0)=>{
            return arg0;
        }
    };
};
const sharedLogger = createTransportLogger("Transport");
export const unwrap = (message, messageDirection, validator = buildNopValidator())=>{
    try {
        let parsed = JSON.parse(message);
        let validated = validator.parse(parsed);
        if (validated.direction !== messageDirection) {
            throw new Error("Message direction incorrect");
        }
        return validated.payload.events;
    } catch (e) {
        sharedLogger.error("Failed to parse incoming message", {
            message,
            error: e
        });
        return [];
    }
};
